import Styles from './Header.module.scss';

type HeaderProps = {
  category: string;
  setCategory: (cat: string) => void;
};
const Header: React.FC<HeaderProps> = ({ category, setCategory }) => {
  const selected = (cat: string) => (category == cat ? 'selected' : '');

  return (
    <div className={Styles['section-card']}>
      <div className={Styles['header']}>
        <p>Latest Releases</p>
      </div>
      <div className={Styles['nlr-navs']}>
        <div
          onClick={() => setCategory('sneakers')}
          className={`${Styles['nlr-nav']} ${Styles[selected('sneakers')]}`}
        >
          <p>Sneakers</p>
          <div className={Styles['selected-line']} />
        </div>
        <div
          onClick={() => setCategory('apparels')}
          className={`${Styles['nlr-nav']} ${Styles[selected('apparels')]}`}
        >
          <p>Apparels</p>
          <div className={Styles['selected-line']} />
        </div>
        <div
          onClick={() => setCategory('handbags')}
          className={`${Styles['nlr-nav']} ${Styles[selected('handbags')]}`}
        >
          <p>Luxury Brand</p>
          <div className={Styles['selected-line']} />
        </div>
      </div>
    </div>
  );
};

export default Header;
